import { Button, Modal, TextField, FormLayout, Form, LegacyStack, Select } from '@shopify/polaris';
import { useState, useCallback, useEffect } from 'react';
import { getDeposits } from '../../../services/depositsService';

export const NewTransferModal = ({ onAddTransfer, disable }) => {
  const [deposits, setDeposits] = useState([]);
  const [optionsOrigin, setOptionsOrigin] = useState(1);
  const [optionsDestination, setOptionsDestination] = useState(1);
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);

  const defaultTransfer = {
    name: '',
    originDepositId: optionsOrigin,
    destinationDepositId: optionsDestination,
  };
  const [transfersForm, setTransfersForm] = useState(defaultTransfer);

  const activator = <Button onClick={handleChange}>Crear transferencia</Button>;
  useEffect(() => {
    getDeposits({ limit: 1000 })
      .then((res) => {
        const p = res.data.data.map((d) => ({ label: d.name, value: parseInt(d.id) }));
        setDeposits(p);
      })
      .catch((e) => {
        throw e;
      });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onAddTransfer(transfersForm);
      setTransfersForm(defaultTransfer);
      setActive(false);
    } catch (e) {}
  };

  const handleOrigin = (value) => {
    setTransfersForm({
      ...transfersForm,
      originDepositId: parseInt(value),
    });
    setOptionsOrigin(parseInt(value));
  };

  const handleDestination = (value) => {
    setTransfersForm({
      ...transfersForm,
      destinationDepositId: parseInt(value),
    });

    setOptionsDestination(parseInt(value));
  };

  return (
    <Modal activator={activator} open={active} onClose={handleChange} title="Crear nuevo traspaso">
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <TextField
              type="name"
              label="Nombre"
              value={transfersForm.name}
              autoComplete="off"
              onChange={(e) => {
                setTransfersForm({
                  ...transfersForm,
                  name: e,
                });
              }}
            />
            <Select label="Depósito de origen" options={deposits} onChange={handleOrigin} value={optionsOrigin} />
            <Select
              label="Depósito de destino"
              options={deposits}
              onChange={handleDestination}
              value={optionsDestination}
            />
            <LegacyStack distribution="center">
              <Button submit primary size="slim">
                CREAR
              </Button>
            </LegacyStack>
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};
